import { Box, Flex, HStack, IconButton } from '@chakra-ui/react';
import type WebUser from 'src/auth/WebUser';
import { useI18n } from 'src/i18n/I18nContext';
import { Button } from '@/components/ui/button';
import LanguageSelect from '../fields/LanguageSelect';
import TimerButton from '../timer/TimerButton';
import { MenuIcon } from '../icons/Icon';
import HeaderBrand from './HeaderBrand';
import ProfileMenu, { getMobileControlColors } from './HeaderProfile';

interface MobileHeaderProps {
    user: WebUser | null;
    path: string;
    isLoginPage: boolean;
    onOpenDrawer: () => void;
    onNavigate: (link: string) => void;
    onLogout: () => void;
}

const MobileHeader = ({
    user,
    path,
    isLoginPage,
    onOpenDrawer,
    onNavigate,
    onLogout,
}: MobileHeaderProps) => {
    const { t } = useI18n();
    const profileActive = ['profile', 'info'].includes(path);
    const controlColors = getMobileControlColors(profileActive);

    return (
        <Flex
            display={{ base: 'flex', lg: 'none' }}
            minH='4rem'
            align='center'
            gap='2'
        >
            <IconButton
                variant='ghost'
                size='md'
                rounded='lg'
                aria-label={t('header.openMenu')}
                borderWidth='1px'
                borderColor={controlColors.borderColor}
                color={controlColors.color}
                bg={controlColors.background}
                _hover={{ bg: controlColors.hoverBackground }}
                onClick={onOpenDrawer}
            >
                <MenuIcon />
            </IconButton>

            <Box flex='1' minW='0'>
                <HeaderBrand user={user?.data ?? null} variant='mobile' onClick={() => onNavigate('/')} />
            </Box>

            <HStack gap='1' flexShrink={0}>
                {user && <TimerButton variant='mobile' role={user?.data.role} />}
                <LanguageSelect />
                {user ? (
                    <ProfileMenu
                        user={user}
                        path={path}
                        variant='mobile'
                        onNavigate={onNavigate}
                        onLogout={onLogout}
                    />
                ) : isLoginPage ? null : (
                    <Button
                        colorPalette='blue'
                        size='sm'
                        rounded='full'
                        px={{ base: '3', sm: '5' }}
                        onClick={() => onNavigate('/login/')}
                    >
                        {t('header.login')}
                    </Button>
                )}
            </HStack>
        </Flex>
    );
};

export default MobileHeader;
